import React from 'react';
import PropTypes from 'prop-types';

export default function X(props) {
  var width = props.width,
      height = props.height,
      color = props.color,
      shapeRendering = props.shapeRendering,
      thickness = props.thickness;


  var path = '';
  var i = void 0;

  for (i = 0; i <= thickness / 2; ++i) {
    path += 'M' + i + ' 0 L' + width + ' ' + (height - i) + ' ';
    path += 'M' + (width - i) + ' 0 L0 ' + (height - i) + ' ';
  }

  for (i = 1; i <= thickness / 2; ++i) {
    path += 'M0 ' + i + ' L' + (width - i) + ' ' + height + ' ';
    path += 'M' + width + ' ' + i + ' L' + i + ' ' + height + ' ';
  }

  var style = { stroke: color, strokeWidth: '1px' };

  return React.createElement(
    'svg',
    { width: width, height: height, style: { shapeRendering: shapeRendering } },
    React.createElement('path', { d: path, style: style })
  );
}

X.displayName = 'X';

X.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  thickness: PropTypes.number.isRequired,
  color: PropTypes.string,
  shapeRendering: PropTypes.string.isRequired
};

X.defaultProps = {
  shapeRendering: 'crispEdges',
  thickness: 1
};
//# sourceMappingURL=X.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/svg/X.js